var _rect, _path, _rect2, _rect3, _rect4, _circle, _circle2, _circle3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcAlchol(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 25.5195,
    y: 19,
    width: 6,
    height: 9,
    rx: 3,
    fill: "#FFECA2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 17C10 16.4477 10.4477 16 11 16H12.5H25.5H27C27.5523 16 28 16.4477 28 17V30C28 32.2091 26.2091 34 24 34H14C11.7909 34 10 32.2091 10 30V17Z",
    fill: "#FFD74B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 19,
    width: 2,
    height: 12,
    rx: 1,
    fill: "#FFECA2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 19,
    width: 2,
    height: 12,
    rx: 1,
    fill: "#FFECA2"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 19,
    width: 2,
    height: 12,
    rx: 1,
    fill: "#FFECA2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 14.5,
    r: 4.5,
    fill: "#FFF3CA"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 5,
    fill: "#FFF3CA"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 12,
    r: 6,
    fill: "#FFF3CA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAlchol);
export default __webpack_public_path__ + "static/media/ic_alchol.3f7327e4b4a4aa25650cddcf1cfaf4be.svg";
export { ForwardRef as ReactComponent };